import { useState } from 'react';
import { cognitoDeleteUser } from '../../../authentication/cognito';
import { Dialog, ButtonVariant, Variant } from '../../../components';
import { PageEvent } from '../../../app-page-events';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';

import '../profile.scss';

export default function ProfileAccount({ onNotifyEvent, onPageUpdateEvent }) {

    const [showDialog, setShowDialog] = useState(false);

    const onDeleteButtonClick = () => {
        setShowDialog(true);
    }

    const onDialogOK = () => {
        setShowDialog(false);
        onAccountDeleteConfirm();
    }

    const onDialogCancel = () => {
        setShowDialog(false);
    }

    const onAccountDeleteConfirm = async () => {

        cognitoDeleteUser().then((result) => {
            setShowDialog(false);
            onNotifyEvent({
                notificationTitle: 'Success',
                notificationMessage: result,
                notificationType: Variant.SUCCESS,
            });

            onPageUpdateEvent(PageEvent.PROFILE_ACCOUNT_DELETED);
        }).catch((error) => {
            setShowDialog(false);
            onNotifyEvent({
                notificationTitle: 'Error',
                notificationMessage: error,
                notificationType: Variant.DANGER,
            });
        });
    }

    return (
        <>
            <Dialog
                show={showDialog}
                title={'Permanently Delete Account?'}
                onOK={onDialogOK}
                onCancel={onDialogCancel}
                buttonOKText={'Delete'}
                buttonOKType={ButtonVariant.DANGER}
                buttonCancelVisible={true}
            >
                {'This will permanently delete your account and all your data. This action cannot be undone.'}
            </Dialog>

            <h4>Account</h4>
            <Container
                className='app-form-group'
            >
                <Button
                    variant={ButtonVariant.DANGER}
                    onClick={onDeleteButtonClick}
                >
                    Delete Account
                </Button>
            </Container>
        </>
    );
}